"use client"

import { useState, useEffect } from "react"
import type { CommunityUser } from "../types"
import { useUserStore } from "../store/user-store"
import { loadUser } from "../service/user-service"

export function useUser(userId: string | undefined): {
  user: CommunityUser | undefined
  loading: boolean
} {
  const user = useUserStore((s) => {
    if (!userId) return undefined
    const realId = s.aliases[userId] ?? userId
    return s.entities[realId]
  })
  const [loading, setLoading] = useState(!user && !!userId)

  useEffect(() => {
    if (!userId) return
    if (user) {
      setLoading(false)
      return
    }
    setLoading(true)
    loadUser(userId).finally(() => setLoading(false))
  }, [userId, user])

  return { user, loading }
}
